<mat-form-field fxFlex.gt-md="60" [formGroup]="group" fxFlex appearance="outline">
  <mat-label>{{field.frontendLabel}}</mat-label>
  <textarea [attr.guide]="'text-area-sel-1' + '__' + sanitizeUrl(url)" trim="blur" [required]="field.isRequired == 1"
    matInput matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5
    [formControlName]="field.attributeCode"></textarea>
  <mat-icon (click)="openEditorDescription(field.attributeCode)" class="editor" matSuffix>post_add</mat-icon>
  <mat-hint fxHide.lt-md>Click on the icon to open editor</mat-hint>
  <div *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
    <mat-error *ngIf="group.get(field.attributeCode).hasError(validation.name)">{{validation.message}}</mat-error>
  </div>
</mat-form-field>